import { render, staticRenderFns } from "./RecommendEventNewsItem.vue?vue&type=template&id=5f87fcfb&scoped=true"
import script from "./RecommendEventNewsItem.vue?vue&type=script&lang=js"
export * from "./RecommendEventNewsItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendEventNewsItem.vue?vue&type=style&index=0&id=5f87fcfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f87fcfb",
  null
  
)

export default component.exports